"use client";
import { useAuthActions } from "@convex-dev/auth/react";
import { useState } from "react";
import { toast } from "sonner";

export function SignInForm() {
  const { signIn } = useAuthActions();
  const [flow, setFlow] = useState<"signIn" | "signUp">("signIn");
  const [submitting, setSubmitting] = useState(false);

  return (
    <div className="w-full space-y-6">
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          setSubmitting(true);
          const formData = new FormData(e.target as HTMLFormElement);
          formData.set("flow", flow);
          void signIn("password", formData).catch((error) => {
            let toastTitle = "";
            if (error.message.includes("Invalid password")) {
              toastTitle = "密码错误，请重试";
            } else {
              toastTitle =
                flow === "signIn"
                  ? "登录失败，您是想要注册吗？"
                  : "注册失败，您是想要登录吗？";
            }
            toast.error(toastTitle);
            setSubmitting(false);
          });
        }}
      >
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-stone-600 mb-2">
              邮箱
            </label>
            <input
              className="w-full px-4 py-3 border border-stone-200 rounded-lg focus:outline-none focus:border-stone-400 transition-colors"
              type="email"
              name="email"
              placeholder="请输入邮箱"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm text-stone-600 mb-2">
              密码
            </label>
            <input
              className="w-full px-4 py-3 border border-stone-200 rounded-lg focus:outline-none focus:border-stone-400 transition-colors"
              type="password"
              name="password"
              placeholder="请输入密码"
              required
            />
          </div>
        </div>
        
        <button 
          className="w-full px-4 py-3 bg-stone-800 text-stone-100 rounded-lg hover:bg-stone-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" 
          type="submit" 
          disabled={submitting}
        >
          {submitting ? (
            <div className="flex items-center justify-center space-x-2">
              <div className="w-4 h-4 border-2 border-stone-100 border-t-transparent rounded-full animate-spin" />
              <span>{flow === "signIn" ? "登录中..." : "注册中..."}</span>
            </div>
          ) : (
            <span>{flow === "signIn" ? "登录" : "注册"}</span>
          )}
        </button>
        
        <div className="text-center">
          <button
            type="button"
            className="text-stone-500 hover:text-stone-700 text-sm transition-colors"
            onClick={() => setFlow(flow === "signIn" ? "signUp" : "signIn")}
          >
            {flow === "signIn" ? "没有账户？点击注册" : "已有账户？点击登录"}
          </button>
        </div>
      </form>
      
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-stone-200" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-3 bg-white text-stone-500">或</span>
        </div>
      </div>
      
      <button 
        className="w-full px-4 py-3 border border-stone-200 text-stone-600 rounded-lg hover:bg-stone-50 transition-colors"
        onClick={() => void signIn("anonymous")}
      >
        匿名访问
      </button>
    </div>
  );
}
